<mat-card>

  <mat-card-content>

    <div class="row"
      style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
      <div class="td-col-md-2" style="width: 5%;" class="mobileview"></div>
      <div class=" themecard card mobileviewmain" style="width: 90%;border-width: 2px; ">


        <mat-card>
          <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
            <mat-card-content>COMMUNITY GOALS FRAMEWORK</mat-card-content>
          </mat-card>
          <div class="card">

            <div class="card-body">
              <p class="card-text p-1">

                The MyJax Community Connect dashboard provides a comprehensive overview of how the City of Jacksonville
                is allocating resources across ten quality of life community goals outlined in the
                <a onclick="window.open('https://nonprofits.coj.net/StrategicPartnerships/CommunityGoalsFramework.aspx','_blank')"
                  style="color: #206aff; cursor: pointer;text-decoration: underline;">
                  Community Goals
                  Framework (linked here)</a>. The charts and tables in the dashboard below serve as an interactive
                snapshot
                of the City of Jacksonville’s investments for Fiscal Years 2019-2022. The City of Jacksonville is
                committed to leveraging data-driven decision-making to create positive outcomes for Jacksonville
                residents, and this dashboard is an essential tool in that effort.
                <br>
                <br>

                <strong style="text-decoration: underline;"> Disclaimer:</strong>
                Information contained on this site is for general information purposes only. Every effort has been
                made to provide information that is current and accurate. Nevertheless, inadvertent data errors may
                occur, and the data on this site may not show a complete picture of the City of Jacksonville’s
                quality-of-life funding investments. Most City of Jacksonville staff salaries are not included in this
                analysis.



                <!-- <a onclick="window.open('https://nonprofits.coj.net/StrategicPartnerships/CommunityGoalsFramework.aspx','_blank')"
                  style="color: #206aff; cursor: pointer;">
                  Jacksonville Community Goals Framework</a> for more information! -->


              </p>

            </div>

          </div>

        </mat-card>
      </div>


    </div>


  </mat-card-content>

  <mat-card-content>
    <div id="print-section" class="">
      <div class="row"
        style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
        <div class="td-col-md-2" style="width: 5%;" class="mobileview"></div>
        <div class=" themecard card mobileviewmain" style="width: 90%;border-width: 2px; ">


          <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
            <mat-card-content>QUALITY OF LIFE DASHBOARD</mat-card-content>
          </mat-card>

          <div class="card-body">
            <!-- <form (keydown)="keyDownFunction($event)"> -->
            <!-- <mat-card> -->
            <mat-card-content>

              <div class="form-group row ">

                <label for="CommunityFramework" class="bgcolor col-md-2 form-control-label" tabindex="0"
                  title="Community Community Goal(s)" aria-label="Community Community Goal(s)">Community Goal(s)<span
                    class="j-color"></span></label>


                <div class="col-md-4">
                  <!-- <select id="CommunityFramework" class="form-control" style="width: 100%;"
                    title="Community Community Goal(s)" aria-label="Community Community Goal(s)"
                    name="Community Community Goal(s)" (change)="cgoalchange()" [(ngModel)]="communityGoal">
                    <option value="0">ALL</option>
                    <option *ngFor="let n of communityGoals" [value]="n.communityGoalsID">
                      {{n.communityGoals}}</option>
                  </select> -->
                  <form [formGroup]="dropDownForm">
                    <ng-multiselect-dropdown placeholder="ALL" id="CommunityFramework" (onSelect)="onItemSelect($event)"
                      (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)"
                      (onDeSelectAll)="onUnSelectAll($event)" (onDropDownClose)="onDropDownClose()"
                      [settings]="dropdownSettings" [data]="dropdownList" [(ngModel)]="cselectedItems"
                      [formControl]="dropDownForm.controls['myItems']">
                    </ng-multiselect-dropdown>
                  </form>
                </div>



                <label for="FiscalYear" class="bgcolor col-md-2 form-control-label" tabindex="0" title="Fiscal Years"
                  aria-label="Fiscal Years">Fiscal Years<span class="j-color"></span></label>
                <div class="col-md-4">
                  <select id="FiscalYear" class="form-control" style="width: 100%;" title="Fiscal Year"
                    aria-label="Fiscal Years" name="FiscalYear" (change)="fyearchange()" [(ngModel)]="FiscalYear">
                    <option value="Total">ALL</option>
                    <!-- <option value="1">2019</option>
                    <option value="2">2020</option>
                    <option value="3">2021</option>
                    <option value="4">2022</option>
                    <option value="5">2023</option> -->
                    <option *ngFor="let n of FiscalYears" [value]="n">
                      {{yearFormat(n)}}</option>
                  </select>
                </div>




              </div>

              <div class="form-group row ">
                <label for="Department" class="bgcolor col-md-2 form-control-label" tabindex="0" title="Department"
                  aria-label="Department">Department(s)<span class="j-color"></span></label>
                <div class="col-md-4">
                  <!-- <select id="Department" class="form-control" style="width: 100%;" title="" aria-label="Department"
                    name="Department" (change)="deptchange()" [(ngModel)]="Department">
                    <option value="0">ALL</option>
                    <option *ngFor="let n of departmentDesc" [value]="n.departmentID">
                      {{n.departmentDesc}}</option>
                  </select> -->

                  <form [formGroup]="dropDownForm1">
                    <ng-multiselect-dropdown id="Departments" placeholder="ALL" [settings]="dropdownSettings1"
                      [data]="dropdownList1" [(ngModel)]="dselectedItems" (onSelect)="donItemSelect($event)"
                      (onSelectAll)="donSelectAll($event)" (onDeSelect)="donItemDeSelect($event)"
                      (onDeSelectAll)="donUnSelectAll($event)" [formControl]="dropDownForm1.controls['myItems1']">
                    </ng-multiselect-dropdown>
                  </form>
                </div>

                <div class="col-md-6">
                  <!-- &nbsp;
                  <button (click)="searchdashboard();"  class="btn btn-success btn-sm" mat-raised-button color="primary">Search</button> -->
                  <!-- &nbsp;&nbsp; -->
                  <button (click)="searchdashboard();" class="btn btn-danger btn-sm" mat-raised-button
                    color="warn">Reset</button>
                  <!-- <button id="btnClear" type="button" (click)="Clearform()" class="btn btn-danger mr-3" tabindex="0"
                    title="clear" aria-label="clear">Reset</button>

                  <button id="btnSubmit" type="button" (click)="searchdashboard()" class="btn btn-primary mr-3"
                    tabindex="0" title="SEARCH" aria-label="Submit">Search</button> -->
                </div>
              </div>
              <br>
              <div class="panel-body">
                <div class="row"
                  style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                  <div class="td-col-md-2" style="width: 10%;" class="mobileview"></div>
                  <div class=" themecard card mobileviewmain" style="width: 100%;border-width: 2px; ">
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                      <mat-card-content>COMMUNITY GOALS FRAMEWORKS (CGF)</mat-card-content>
                    </mat-card>

                    <form (keydown)="keyDownFunction($event)">
                      <div>
                        <div class="row ">



                          <div class="col-lg-8">

                            <div id="chart" *ngIf="display">
                              <p style="color:red;">{{investmenttotalsmessage}}</p>
                              <apx-chart [series]="chartOptions?.series" [chart]="chartOptions.chart"
                                [labels]="chartOptions.labels" [colors]="chartOptions.colors"
                                [responsive]="chartOptions.responsive" [tooltip]="chartOptions.tooltip"></apx-chart>

                            </div>
                          </div>

                          <div style="padding-right: 40px;" class="col-lg-4">
                            <mat-chip-option color="accent"
                              style="font-size:22px;cursor: pointer;color:blue;float: right;" (click)="onNavigate()"
                              selected>Learn More...</mat-chip-option>

                            <!-- <p tabindex="0" class="model-content"><span
                                style="font-weight: 500; font-size: 16px; line-height: 1.0000143; color: #2355b7;"><a
                                  style="color:blue;cursor: pointer;" (click)="onNavigate()">
                                  Learn More...</a> </span></p>  -->

                            <!-- <button style="float:right" mat-raised-button color="warn" (click)="onNavigate()">Learn More...</button> -->

                            <br>
                            <app-piechartgrid [fyear]="FiscalYear" [(cgoalid)]="communityGoal" [(deptid)]="Department">
                            </app-piechartgrid>
                          </div>
                        </div>
                      </div>
                      <br>
                    </form>
                    <br>
                    <!-- <div class="row">
                      <div style="width: 100%;">
                        <div class="panel-heading model-content" style="margin-bottom: 0.5%;">
                          <div class="my-container" style="background-color: white;">
                            <div role="contentinfo" class="modal-body">
                              <p tabindex="0" class="model-content"><span
                                  style="font-weight: 500; font-size: 15px; line-height: 1.0000143; color: #2355b7;">
                                  <strong
                                    title="NOTE: Please visit Resources section to learn more about Community Goals Framework and the specific goals "></strong><span
                                    style="text-decoration: underline;">NOTE:</span>
                                  Please visit <a style="color:blue;cursor: pointer;"
                                    (click)="onNavigate()">Resources</a> section to learn more about Community
                                  Goals Framework and the specific goals. </span></p>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <br>
              <div class="panel-body">
                <div class="row"
                  style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                  <div class="td-col-md-2" style="width: 10%;" class="mobileview"></div>
                  <div class=" themecard card mobileviewmain" style="width: 100%;border-width: 2px; ">
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                      <mat-card-content>INVESTMENTS BY COMMUNITY GOAL(s)</mat-card-content>
                    </mat-card>
                    <div>
                      <p style="font-size:22px;cursor:pointer;color:blue;float:right;margin-left:30px;"
                        (click)="onNavigate()">Learn More...</p>
                    </div>
                    <div class="card-body">

                      <div class="col-lg-12">
                        <!-- <div id="chart2">
                              <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart2"
                                [dataLabels]="chartOptions2.dataLabels" [plotOptions]="chartOptions2.plotOptions"
                                [responsive]="chartOptions2.responsive" [xaxis]="chartOptions2.xaxis"
                                 [colors]="chartOptions2.colors"
                                [legend]="chartOptions2.legend" [fill]="chartOptions2.fill"></apx-chart>
                            </div>  -->
                        <ng-container *ngIf="cbchartVisible">
                          <google-chart #chart [type]="type" [data]="data" [columns]="columnNames" [options]="options">
                          </google-chart>
                        </ng-container>
                        <ng-container *ngIf="!cbchartVisible">
                          <p style="color:red;">NO DATA!!</p>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br>

              <div class="panel-body">
                <div class="row"
                  style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                  <div class="td-col-md-2" style="width: 10%;" class="mobileview"></div>
                  <div class=" themecard card mobileviewmain" style="width: 100%;border-width: 2px; ">
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                      <mat-card-content>INVESTMENTS BY DEPARTMENTS</mat-card-content>
                    </mat-card>
                    <div>
                      <p style="font-size:22px;cursor:pointer;color:blue;float:right;margin-left:30px;"
                        (click)="onNavigate()">Learn More...</p>
                    </div>

                    <div class="card-body">


                      <div class="col-lg-12">
                        <ng-container *ngIf="dbchartVisible">
                          <google-chart #dchart [type]="type" [data]="deptdata" [columns]="dcolumnNames"
                            [options]="doptions">
                          </google-chart>
                        </ng-container>
                        <ng-container *ngIf="!dbchartVisible">
                          <p style="color:red;">NO DATA!!</p>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="panel-body">
                <div class="row"
                  style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                  <div class="td-col-md-2" style="width: 10%;" class="mobileview"></div>
                  <div class=" themecard card mobileviewmain" style="width: 100%;border-width: 2px; ">
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                      <mat-card-content>Investments by Departments</mat-card-content>
                    </mat-card>
                    <div class="card-body">
                      <form (keydown)="keyDownFunction($event)">
                        <div class="row">
                          <div class="col-lg-12">
                            <div>
                            </div>
                            <div id="chart3">
                              <apx-chart [series]="chartOptions3.series" [chart]="chartOptions3.chart3"
                                [dataLabels]="chartOptions3.dataLabels" [plotOptions]="chartOptions3.plotOptions"
                                [responsive]="chartOptions3.responsive" [xaxis]="chartOptions3.xaxis"
                                [colors]="chartOptions3.colors" [legend]="chartOptions3.legend"
                                [fill]="chartOptions3.fill"></apx-chart>
                            </div>
                          </div>
                        </div>
                      </form>
                      <br>
                      <br>


                    </div>
                  </div>
                </div>
              </div> -->
              <br>
              <div class="panel-body">
                <div class="row"
                  style="padding-top: 2px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
                  <div class="td-col-md-2" style="width: 10%;" class="mobileview"></div>
                  <div class=" themecard card mobileviewmain" style="width: 100%;border-width: 2px; ">
                    <mat-card tabindex="0" style="color:white; background-color: #11446f; border: 1px solid #f1b122;">
                      <mat-card-content>QUALITY OF LIFE INVESTMENTS</mat-card-content>
                    </mat-card>
                    <form (keydown)="keyDownFunction($event)">
                      <div class="col-lg-12">
                        <app-projectlist [fyear]="FiscalYear" [cgoalid]="communityGoal" [deptid]="Department">
                        </app-projectlist>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
  <br>
</mat-card>